/**
 * Auth module exports.
 * Spec 0043: Umstellung auf SRP Direct Auth (kein Hosted UI Redirect mehr).
 *
 * @see Spec 0043 — Custom Login Flow
 */

export type { AuthProvider as AuthProviderInterface, CognitoClaims, SignInResult } from './types';
export { AuthContext, AuthProvider, useAuth } from './context';

// Export the active auth provider — SRP Direct Auth
import { cognitoDirectProvider } from './cognito-direct';
export const auth = cognitoDirectProvider;
